import React from 'react';
import PropTypes from 'prop-types';

const OptionList = (props) => {
  const options = Object.assign([], props.options);

  if(props.createDefaultOption) {
    options.unshift({ "value": "", "text": "Choose from options" });
  }

  return options.map((option, index) =>
    <option key={option.value} value={option.value} disabled={index === 0 && props.createDefaultOption}>{option.text}</option>);
};

OptionList.defaultProps = {
  createDefaultOption: true
};

OptionList.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  })).isRequired,
  createDefaultOption: PropTypes.bool
};

export default OptionList;

export const YesOrNoOptionList = () => <OptionList options={[
  { "value": "true", "text": "Yes" },
  { "value": "false", "text": "No" }
]}/>;
